import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowUpRight } from "lucide-react";
import { login, checkAuth } from "@/lib/auth";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      const u = await checkAuth();
      if (u) navigate("/admin");
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Inloggen mislukt.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-cgdark flex items-center justify-center p-5 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-20" />
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-cgprimary/10 rounded-full blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <Lock size={16} className="text-cgprimary" />
            <span className="text-cgprimary text-[10px] font-bold tracking-[0.3em] uppercase">Admin toegang</span>
          </div>
          <h1 className="font-heading text-white text-3xl md:text-4xl font-bold tracking-tight leading-tight">
            Cargides <span className="text-cgprimary italic font-light">admin</span>
          </h1>
          <p className="text-white/50 text-sm mt-3">Log in om vacatures te beheren.</p>
        </div>

        <form onSubmit={submit} className="bg-white p-6 md:p-8" data-testid="admin-login-form">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.2em] text-cgmuted font-semibold mt-2">E-mail</label>
            <input
              type="email"
              className="cg-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.2em] text-cgmuted font-semibold mt-4">Wachtwoord</label>
            <input
              type="password"
              className="cg-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <div className="mt-6 border-l-2 border-red-500 bg-red-50 p-3 text-red-700 text-sm" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="cg-btn-primary w-full justify-center mt-8"
            disabled={loading}
            data-testid="admin-login-submit"
          >
            {loading ? "Inloggen..." : "Inloggen"} <ArrowUpRight size={16} />
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-white/50 hover:text-white text-xs tracking-[0.15em] uppercase link-underline">
            ← Terug naar website
          </a>
        </div>
      </div>
    </div>
  );
}
